<template>
  <div>
    <vxe-table
      align="center"
      border
      resizable
      show-overflow
      ref="xTable"
      min-height="214"
      :data="tableData1"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      @edit-actived="editActivedEvent">
      <vxe-column type="checkbox" width="50"></vxe-column>
      <vxe-column type="seq" width="55"></vxe-column>
      <vxe-colgroup title="现有情况">
        <vxe-column field="jobName" title="职位名称" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.jobName" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="peopleType" title="人才类别" :edit-render="{}">
          <template #default="{ row }">
            <span>{{ formatRole(row.peopleType, roleList1) }}</span>
          </template>
          <template #edit="{ row }">
            <vxe-select v-model="row.peopleType" clearable transfer @change="roleChangeEvent">
              <vxe-option v-for="item in roleList1" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
            </vxe-select>
          </template>
        </vxe-column>
        <vxe-column field="research" title="研究方向" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.research" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="number" title="人才数量" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.number" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
      <vxe-colgroup title="需求情况">
        <vxe-column field="proposedJobTitle" title="拟提供职位名称" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.proposedJobTitle" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="talentCategory" title="人才类别" :edit-render="{}">
          <template #default="{ row }">
            <span>{{ formatRole(row.talentCategory, roleList1) }}</span>
          </template>
          <template #edit="{ row }">
            <vxe-select v-model="row.talentCategory" clearable transfer @change="roleChangeEvent">
              <vxe-option v-for="item in roleList1" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
            </vxe-select>
          </template>
        </vxe-column>
        <vxe-column field="needResearch" title="研究方向" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.needResearch" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="way" title="拟引进方式" :edit-render="{}">
          <template #default="{ row }">
            <span>{{ formatRole(row.way, roleList2) }}</span>
          </template>
          <template #edit="{ row }">
            <vxe-select v-model="row.postName" clearable transfer @change="roleChangeEvent">
              <vxe-option v-for="item in roleList2" :key="item.value" :value="item.value" :label="item.label" :disabled="item.disabled"></vxe-option>
            </vxe-select>
          </template>
        </vxe-column>
        <vxe-column field="needNumber" title="拟引进数量" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.needNumber" min="0" type="integer"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column width="180" field="project" title="拟攻关的重大项目（需填写项目简介，200字左右，包含相关关键技术，主要社会效益等）" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.project" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="platform" title="具备的研发平台" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.platform" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="support" title="可提供的支持" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.support" type="text"></vxe-input>
          </template>
        </vxe-column>
        <vxe-column field="emolument" title="可提供的薪酬" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.emolument" type="text"></vxe-input>
          </template>
        </vxe-column>
      </vxe-colgroup>
    </vxe-table>
    <vxe-toolbar>
      <template #buttons>
        <vxe-button @click="insertEvent()">新增</vxe-button>
        <vxe-button @click="$refs.xTable.removeCheckboxRow()">删除选中</vxe-button>
      </template>
    </vxe-toolbar>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'surveItem4',
  components: {},
  data() {
    return {
      tableData1: [{}],
      roleList1: [
        { label: '顶尖人才', value: '顶尖人才', disabled: false },
        { label: '国家级领军人才', value: '国家级领军人才', disabled: false },
        { label: '省级领军人才', value: '省级领军人才', disabled: false },
        { label: '高级技术专家', value: '高级技术专家', disabled: false },
      ],
      roleList2: [
        { label: '全职引进', value: '全职引进', disabled: false },
        { label: '柔性引进', value: '柔性引进', disabled: false },
      ],
      roleList3: [
        { label: '生产类', value: '生产类', disabled: false },
        { label: '实施类', value: '实施类', disabled: false },
        { label: '运维类', value: '运维类', disabled: false },
        { label: '其他', value: '其他', disabled: false },
      ],
    };
  },

  created() {},
  mounted() {
    this.$nextTick(() => {
      this.updateRoleList();
    });
  },

  methods: {
    moment,
    resetEvent() {},
    insertEvent() {
      const $table = this.$refs.xTable;
      const record = {};
      $table.insert(record);
    },
    formatRole(value, arr) {
      const item = arr.find((item) => item.value === value);
      return item ? item.label : value;
    },
    updateRoleList() {
      const $table = this.$refs.xTable;
      // 获取表格中的全量数据
      const { fullData } = $table.getTableData();
    },
    roleChangeEvent({ row }) {
      this.updateRoleList();
    },
    editActivedEvent({ row }) {
      // 激活编辑时检查剩余选项是否可选择
      this.updateRoleList();
    },
  },
};
</script>

<style lang="less" scoped></style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
